(function () {
  if (window.__freeShippingBarLoaded) return;
  window.__freeShippingBarLoaded = true;

  const cartUrl = (window.Shopify?.routes?.root || '/') + 'cart.js';

  let updateTimer;
  let requestId = 0;

  function formatMoney(cents, format) {
    const value = (cents / 100).toFixed(2);

    const formatWithDelimiters = (number, precision, thousands, decimal) => {
      const parts = Number(number).toFixed(precision).split('.');
      const integer = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return integer + (parts[1] ? decimal + parts[1] : '');
    };

    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);

    if (!match) {
      return value;
    }

    let formatted;

    switch (match[1]) {
      case 'amount_no_decimals':
        formatted = formatWithDelimiters(cents / 100, 0, ',', '.');
        break;

      case 'amount_with_comma_separator':
        formatted = formatWithDelimiters(cents / 100, 2, '.', ',');
        break;

      case 'amount_no_decimals_with_comma_separator':
        formatted = formatWithDelimiters(cents / 100, 0, '.', ',');
        break;

      default:
        formatted = formatWithDelimiters(cents / 100, 2, ',', '.');
    }

    return format.replace(/\{\{\s*\w+\s*\}\}/, formatted);
  }

  async function updateShippingBars() {
    const bars = document.querySelectorAll('[data-free-shipping-bar]');

    if (!bars.length) return;

    const currentRequest = ++requestId;

    try {
      const response = await fetch(cartUrl, {
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!response.ok) return;

      const cart = await response.json();

      if (currentRequest !== requestId) return;

      document.querySelectorAll('[data-free-shipping-bar]').forEach(bar => {
        const threshold = Number(bar.dataset.threshold);
        const total = Number(cart.total_price);

        // Hide progress bar when cart is empty
        if (cart.item_count === 0) {
        bar.hidden = true;
        return;
        }

        // Show progress bar when cart has products
        bar.hidden = false;

        if (!threshold || threshold <= 0) return;

        const remaining = Math.max(0, threshold - total);
        const progress = Math.min(100, Math.max(0, (total / threshold) * 100));

        const progressText = bar.dataset.progressTemplate || '';
        const successText = bar.dataset.successTemplate || '';
        const moneyFormat = bar.dataset.moneyFormat || '{{amount}}';

        const message = remaining > 0
          ? progressText.replace(/\[amount\]/g, formatMoney(remaining, moneyFormat))
          : successText;

        const textElement = bar.querySelector('.custom-free-shipping__text');
        const fillElement = bar.querySelector('.custom-free-shipping__progress');
        const trackElement = bar.querySelector('.custom-free-shipping__bar');

        if (textElement) {
          textElement.textContent = message;
        }

        if (fillElement) {
          fillElement.style.width = progress + '%';
        }

        if (trackElement) {
          trackElement.setAttribute('aria-valuenow', Math.round(progress));
        }
      });

    } catch (error) {
      console.warn('Free shipping update failed:', error);
    }
  }

  function scheduleUpdate() {
    clearTimeout(updateTimer);
    updateTimer = setTimeout(updateShippingBars, 300);
  }

  document.addEventListener('DOMContentLoaded', updateShippingBars);

  document.addEventListener('cart:updated', scheduleUpdate);
  document.addEventListener('cart:refresh', scheduleUpdate);
  document.addEventListener('cart:change', scheduleUpdate);

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    const request = args[0];
    const url = typeof request === 'string' ? request : request?.url || '';

    if (
      response.ok &&
      /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)
    ) {
      scheduleUpdate();
    }

    return response;
  };

  // Detect cart drawer HTML replacement.
  function startObserver() {
    const observer = new MutationObserver(mutations => {
      const newBarAdded = mutations.some(mutation =>
        Array.from(mutation.addedNodes).some(node =>
          node.nodeType === 1 &&
          (
            node.matches?.('[data-free-shipping-bar]') ||
            node.querySelector?.('[data-free-shipping-bar]')
          )
        )
      );

      if (newBarAdded) scheduleUpdate();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
    updateShippingBars();
  }
})();